module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "note-list"
    }
  }, [_c('div', {
    attrs: {
      "id": "list-header"
    }
  }, [_c('h2', [_vm._v("Notes | chenmf")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group btn-group-justified",
    attrs: {
      "role": "group"
    }
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    class: {
      active: _vm.show === 'all'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setShow('all')
      }
    }
  }, [_vm._v("\n          All Notes\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    class: {
      active: _vm.show === 'favorites'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setShow('favorites')
      }
    }
  }, [_vm._v("\n          Favorites\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "notes-counter"
  }, [_c('span', [_vm._v(_vm._s(_vm.filteredNotes.length) + " notes ")])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.filteredNotes), function(note) {
    return _c('li', {
      staticClass: "list-group-item",
      class: {
        active: _vm.activeNote === note
      },
      on: {
        "click": function($event) {
          _vm.setActiveNote(note)
        }
      }
    }, [_c('h4', {
      staticClass: "list-group-item-heading"
    }, [_vm._v("\n          " + _vm._s(note.title ? note.title.trim() : 'New Note') + "\n        ")]), _vm._v(" "), _c('p', {
      staticClass: "list-group-item-body"
    }, [_vm._v("\n          " + _vm._s(note.content ? note.content.trim() : 'Empty note.') + "\n        ")]), _vm._v(" "), _c('span', {
      staticClass: "list-group-item-date"
    }, [_vm._v("\n          " + _vm._s(new Date(note.date).toLocaleString()) + "\n        ")])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-793365f8","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoteList.vue
// module id = 68
// module chunks = 1